import type { ReactNode } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

interface AuthPageShellProps {
  title: string;
  description?: string;
  children: ReactNode;
  maxWidthClassName?: string;
}

export default function AuthPageShell({
  title,
  description,
  children,
  maxWidthClassName = 'max-w-md',
}: AuthPageShellProps) {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center transition-colors duration-200 px-4">
      <div className="absolute top-4 right-4">
        <button
          onClick={toggleTheme}
          className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-200"
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        </button>
      </div>
      <div className={`${maxWidthClassName} w-full bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 transition-colors duration-200`}>
        <h2 className="text-2xl font-bold text-center text-gray-800 dark:text-white mb-3">
          {title}
        </h2>
        {description ? (
          <p className="text-sm text-center text-gray-600 dark:text-gray-300 mb-8">
            {description}
          </p>
        ) : null}
        {children}
      </div>
    </div>
  );
}
